/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Frustrating_QuestionInputs */

const en_onboarding_frustrating_question = /** @type {(inputs: Onboarding_Frustrating_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's most frustrating part of your current reading process?`)
};

const es_onboarding_frustrating_question = /** @type {(inputs: Onboarding_Frustrating_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es lo más frustrante de tu proceso de lectura actual?`)
};

/**
* | output |
* | --- |
* | "What's most frustrating part of your current reading process?" |
*
* @param {Onboarding_Frustrating_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_frustrating_question = /** @type {((inputs?: Onboarding_Frustrating_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Frustrating_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_frustrating_question(inputs)
	return en_onboarding_frustrating_question(inputs)
});